import React from 'react';

import InputSelectField from '../Fields/InputSelectField';

import './DataTableLimit.scss';

class DataTableLimit extends React.Component {
  state = {
    limit: 'all'
  };

  defaultOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '10', label: '10' },
    { value: 'all', label: 'all' }
  ];

  static getDerivedStateFromProps(props, state) {
    return {
      limit: (props.value) ? String(props.value) : 'all'
    };
  }

  handleLimitChange = value => {
    this.setState({ limit: value });

    const parsedValue = (value === 'all') ? null : parseInt(value);
    this.props.onChange(parsedValue);
  }

  render() {
    return (
      <div className="parkchirp--data-table-option parkchirp--data-table-option--limit">
        <span>Display</span>
        <InputSelectField
          inputId={`parkchirp--data-table--${this.props.dataTableId}--limit`}
          options={this.props.options || this.defaultOptions}
          value={this.state.limit}
          onChange={this.handleLimitChange}
          editMode={true}
        />
        <span>records at a time.</span>
      </div>
    );
  }
}

export default DataTableLimit;
